import { render, staticRenderFns } from "./audioPlay.vue?vue&type=template&id=4b9a6978&scoped=true"
import script from "./audioPlay.vue?vue&type=script&lang=js"
export * from "./audioPlay.vue?vue&type=script&lang=js"
import style0 from "./audioPlay.vue?vue&type=style&index=0&id=4b9a6978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a6978",
  null
  
)

export default component.exports